import { ReactComponent as TournamentSidebarSvg } from "../../assets/images/svgs/tournamentSidebar.svg";

const TournamentSidebarIcon = ({ className = "", ...props }) => {
  return (
    <TournamentSidebarSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default TournamentSidebarIcon;
